export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  GET_BY_ID: 'GET_BY_ID',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
}
